<template>
    <div>
        <yes-no-question
            id="allergyToTreatment"
            v-model="allergyToTreatment"
            :required="required"
            :in-review="isReviewing"
            @change="allergyToTreatmentChanged"
            @input="update"
        >
            <template slot="label"
                >{{ $t("pages.forms.skin.allergy-treat.title")
                }}<span v-if="required" :class="requiredClasses"
                    >*</span
                ></template
            >
        </yes-no-question>

        <b-form-group
            label-for="allergyToTreatmentText"
            v-show="isAllergyToTreatmentTextFieldRequired"
        >
            <template slot="label"
                >{{ $t("pages.forms.skin.allergy-treat.title-other")
                }}<span
                    v-if="isAllergyToTreatmentTextFieldRequired"
                    :class="requiredClasses"
                    >*</span
                ></template
            >
            <validation-provider
                rules="required_if:allergyToTreatment,1"
                v-slot="{ dirty, valid, validated, errors }"
            >
                <b-form-input
                    id="allergyToTreatmentText"
                    v-model="allergyToTreatmentText"
                    :state="dirty || validated ? valid : null"
                    :required="isAllergyToTreatmentTextFieldRequired"
                    @input="update"
                    v-show="!isReviewing"
                />
                <b-form-invalid-feedback
                    :state="dirty || validated ? valid : null"
                    >{{ errors[0] }}</b-form-invalid-feedback
                >
            </validation-provider>
            <b-form-input
                type="text"
                readonly
                plaintext
                v-show="isReviewing"
                :value="allergyToTreatmentTextWhenReviewing"
            />
        </b-form-group>
    </div>
</template>

<script>
import FormInputHelpers from "../../../../mixins/FormInputHelpers";
import { ValidationProvider } from "vee-validate";

export default {
    mixins: [FormInputHelpers],
    components: { ValidationProvider },
    data() {
        return {
            allergyToTreatment: this.value.allergyToTreatment,
            allergyToTreatmentText: this.value.allergyToTreatmentText
        };
    },
    props: {
        value: {
            type: Object,
            default() {
                return {
                    allergyToTreatment: null,
                    allergyToTreatmentText: null
                };
            }
        },
        required: {
            type: Boolean,
            default: false
        },
        reviewing: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        update() {
            this.$emit("input", {
                allergyToTreatment: this.allergyToTreatment,
                allergyToTreatmentText: this.allergyToTreatmentText
            });
        },
        allergyToTreatmentChanged(toValue) {
            if (toValue === 0) {
                this.allergyToTreatmentText = null;
            }
        }
    },
    computed: {
        isAllergyToTreatmentTextFieldRequired() {
            return 1 === this.allergyToTreatment;
        },
        allergyToTreatmentTextWhenReviewing() {
            return this.allergyToTreatmentText;
        },
        allergyToTreatmentValue() {
            return this.allergyToTreatment === 1 ? "Sí" : "No";
        },
        isReviewing() {
            return this.reviewing;
        }
    }
};
</script>

<style scoped></style>
